import { render, staticRenderFns } from "./blockText.vue?vue&type=template&id=7551df92&scoped=true&"
import script from "./blockText.vue?vue&type=script&lang=js&"
export * from "./blockText.vue?vue&type=script&lang=js&"
import style0 from "./blockText.vue?vue&type=style&index=0&id=7551df92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551df92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
